import type { ISbStoryData as Story } from '@storyblok/js';
import { isPageNewsReference } from '~/utils/isPageNewsReference';

export const useResolvedNewsStory = () => {
    const getFirstReference = (story: Story) => {
        const reference = story.content?.reference;

        if (!Array.isArray(reference)) {
            return null;
        }

        return reference[0] ?? null;
    };

    const getReferenceUuid = (story: Story): string | null => {
        if (!isPageNewsReference(story)) {
            return null;
        }

        const firstReference = getFirstReference(story);

        if (typeof firstReference === 'string') {
            return firstReference;
        }

        if (firstReference && typeof firstReference === 'object') {
            return firstReference.uuid ?? null;
        }

        return null;
    };

    const getResolvedReferenceStory = (story: Story, referencedStories: Story[] = []) => {
        if (!isPageNewsReference(story)) {
            return null;
        }

        const firstReference = getFirstReference(story);

        if (!firstReference) {
            return null;
        }

        if (typeof firstReference === 'object' && Object.keys(firstReference).length > 0) {
            return firstReference;
        }

        if (typeof firstReference === 'string') {
            return referencedStories.find((item) => item.uuid === firstReference) ?? null;
        }

        return null;
    };

    const normalizeNewsCardStory = (story: Story, referencedStories: Story[] = []) => {
        if (!isPageNewsReference(story)) {
            return story;
        }

        const referencedStory = getResolvedReferenceStory(story, referencedStories);

        if (!referencedStory) {
            return null;
        }

        return {
            ...story,
            content: referencedStory.content,
            referencedStory,
            isReference: true
        };
    };

    return {
        getReferenceUuid,
        normalizeNewsCardStory
    };
};
